// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__LogoMaker from "../LogoMaker.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const selectedName = Cn.fromList({
  hd: "items-center justify-between whitespace-nowrap ml-4 flex",
  tl: {
    hd: "",
    tl: /* [] */ 0
  }
});

const Styles = {
  selectedName: selectedName
};

function nameTrimmed(name) {
  const name$1 = name.replace(/[^a-zA-Z0-9Ёёа-яА-Я-әғқңөұүһіІі.,\s-]/g, "").trim();
  return Belt__Belt_List.reduce({
    hd: "ип",
    tl: {
      hd: "тоо",
      tl: {
        hd: "too",
        tl: {
          hd: "жшс",
          tl: {
            hd: "жшc",
            tl: {
              hd: "жк",
              tl: {
                hd: "жеке кәсіпкер",
                tl: {
                  hd: "жауапкершілігі шектеулі серіктестік",
                  tl: {
                    hd: "товарищество с ограниченной ответственностью",
                    tl: {
                      hd: "индивидуальный предприниматель",
                      tl: /* [] */ 0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }, name$1, (function (name, currentNameToDelete) {
    if (name.toLowerCase().indexOf(currentNameToDelete, undefined) === 0) {
      return name.slice(currentNameToDelete.length, undefined);
    } else {
      return name;
    }
  })).trim();
}

function OrgSwitcher(Props) {
  let org = Props.org;
  let setBar = Props.setBar;
  const jitsu = JitsuReact.useJitsu();
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match[0];
  let orgs;
  let exit = 0;
  if (/* tag */ typeof identity === "number" || typeof identity === "string") {
    orgs = /* [] */ 0;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    orgs = Belt__Belt_List.keepMap(identity._0.tenants, (function (tenant) {
      const match = tenant.tenant;
      if (match === undefined) {
        return;
      }
      const match$1 = match.info;
      if (typeof match$1 === "string" || match$1.NAME !== "Org") {
        return;
      } else {
        return match$1.VAL;
      }
    }));
  }
  const match$1 = React.useState(function () {
    return false;
  });
  const setIsDropdownShown = match$1[1];
  const name = org.name;
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("button", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__LogoMaker.make, {
            name: nameTrimmed(name),
            size: "w-6 h-6",
            textSize: "m",
            className: "shrink-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                className: Cn.fromList({
                  hd: "truncate w-32 text-left text-white",
                  tl: {
                    hd: Cn.on("w-auto", name.length < 15),
                    tl: /* [] */ 0
                  }
                }),
                title: name,
                children: name
              }),
              JsxRuntime.jsx("img", {
                className: "shrink-0",
                src: StaticAsset.src("/static/icons/select-arrows-white.svg")
              })
            ],
            className: selectedName
          })
        ],
        className: "flex cursor-pointer px-2 md:px-6 py-1.5 md:mt-6 bg-asphalt-dark md:bg-transparent rounded-md",
        onClick: (function (param) {
          Curry._1(setIsDropdownShown, (function (param) {
            return true;
          }));
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.H6.make, {
              className: "px-2 pt-1 text-default-gray",
              children: "Подключенные предприятия"
            }),
            JsxRuntime.jsx("hr", {
              className: "mt-2 mb-1"
            }),
            Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, item) {
              const Key = String(i);
              return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                route: {
                  TAG: /* Org */ 6,
                  _0: item.id,
                  _1: /* Dashboard */ 0
                },
                className: "px-2 py-1.5 flex gap-3 items-center hover:bg-gray-pale cursor-pointer",
                onLinkClicked: (function (param) {
                  Curry._1(setIsDropdownShown, (function (param) {
                    return false;
                  }));
                  Curry._1(setBar, (function (param) {
                    return "main";
                  }));
                  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
                    return;
                  }
                  switch (currentRoute.TAG) {
                    case /* Org */ 6 :
                      let tmp = currentRoute._1;
                      if (/* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* Kassa */ 2) {
                        return;
                      } else {
                        return Curry._1(jitsu.analytics.track, "kassa.kkms.choose_organization");
                      }
                    case /* Admin */ 7 :
                      const match = currentRoute._0;
                      if (/* tag */ typeof match === "number" || typeof match === "string") {
                        return;
                      }
                      if (match.TAG !== /* Orgs */ 1) {
                        return;
                      }
                      const match$1 = match._0;
                      if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string") {
                        return;
                      }
                      let tmp$1 = match$1._1;
                      if (/* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* Kassa */ 2) {
                        return;
                      } else {
                        return Curry._1(jitsu.analytics.track, "kassa.kkms.choose_organization");
                      }
                    default:
                      return;
                  }
                }),
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__LogoMaker.make, {
                    name: nameTrimmed(item.name),
                    size: "w-6 h-6",
                    textSize: "m",
                    className: "shrink-0"
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "whitespace-nowrap overflow-hidden text-ellipsis text-black",
                    title: name,
                    children: item.name
                  })
                ]
              }, Key);
            }), orgs))
          ],
          className: "bg-white w-60 p-2 shadow-kkms rounded-sm max-h-200 overflow-auto"
        }),
        className: Cn.$plus("absolute inset-0 pt-14 md:pt-26 pl-4 z-10", Cn.on("hidden", !match$1[0])),
        onClick: (function (param) {
          Curry._1(setIsDropdownShown, (function (param) {
            return false;
          }));
        })
      })
    ]
  });
}

const make = OrgSwitcher;

export {
  Styles,
  nameTrimmed,
  make,
}
/* selectedName Not a pure module */
